// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"e241d24f","366":"6b5382da","717":"6b5382da","758":"6b5382da","845":"b29b8c50"}[chunkId] + ".chunk.css";
};